<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--sm">

                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-question-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">Enregistrement</h4>
                                <p class="cf-modal-head__sub">Confirmation requise</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">
                        <div v-if="messagesucces!==''" class="cf-note cf-note--info" style="margin-bottom:0.75rem;">
                            <i class="ri-check-circle-line"></i><span v-html="messagesucces"></span>
                        </div>
                        <div v-if="messageerror!==''" class="cf-note cf-note--danger" style="margin-bottom:0.75rem;">
                            <i class="ri-error-warning-line"></i><span v-html="messageerror"></span>
                        </div>

                        <div class="cf-note cf-note--info">
                            <i class="ri-information-line"></i>
                            <span v-html="titlemodal"></span>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Non</button>
                        <button @click="btnsuppression" type="button" class="ti-btn ti-btn-primary-full">
                            <i class="ri-check-line align-middle"></i> Oui
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>

    //import allfunction from "@/allfunction";
    import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "formsupp",
        watch: {


        },

        computed:{




        },
        components: {


        },

        data() {
            return {
                isdisplay:false,
                datavalue:"",
                titlemodal:"",
                Items:{},
                typedoc:"",
                messageerror:"",
                messagesucces:"",
            };
        },
        methods: {

            close(){

                this.isdisplay=false;


            },


            show(titlemodal,Items,typedoc){
                this.messagesucces="";
                this.messageerror="";
                this.titlemodal=titlemodal
                this.Items=Items
                this.typedoc=typedoc

                this.isdisplay=true;

            },


            async  btnsuppression(){

                this.$store.dispatch('lancerchargement',true)

                this.Items.cf=this.$store.state.caisseinfo;
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/doc/caisse/addfkdfkdozojdj_refdepdpcc/'+this.$store.state.appsociete+'/add895418init51_refdepdpcc11515/'+randomString();
                let response =   axios  .post(url,this.Items,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){

                            t.messagesucces="";
                            t.messageerror="";

                            t.messagesucces=res.data.message;

                            toastr['success']( t.messagesucces,"<b></b>");


                            t.$emit('aftervalidation',res.data.m);

                            t.isdisplay=false;


                        }
                        else{

                            let errormessage="";

                            t.messageerror="";
                            t.messagesucces="";
                            if (res.data.datamessage.length>0){

                                for (let message of res.data.datamessage){

                                    if (errormessage===""){

                                        errormessage=message;

                                    }else{

                                        errormessage+=" , "+message;

                                    }


                                }


                                t.messageerror=errormessage;

                            }
                            else{
                                t.messageerror=res.data.message
                            }


                            toastr['error'](t.messageerror,"<b></b>");

                            t.isdisplay=false;

                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>")
                    )
                    .finally(() => this.$store.dispatch('lancerchargement',false))




            },







        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--sm { max-width:460px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--sm { max-width:100%; } }
</style>